/** 超级管理员在 PC 上强制预览移动端布局（默认 desktop） */
export const LAYOUT_PREVIEW_DESKTOP = 'desktop'
export const LAYOUT_PREVIEW_MOBILE = 'mobile'

export function isMobileLayoutActive(device, layoutPreviewMode) {
  return device === 'mobile' || layoutPreviewMode === LAYOUT_PREVIEW_MOBILE
}



// WEBPACK FOOTER //
// ./src/utils/layoutPreviewMode.js